import { usePreisToolSalesHistory } from '@/api/preis-tool/preis-tool.hooks';
import { DsButton, DsModal } from '@/modules/internal-v2/ds';
import { fmtDate, fmtEUR } from '../helpers';

interface SalesHistoryDialogProps {
  itemId: string;
  itemName: string;
  onClose: () => void;
}

const pieces = (n: number) => n.toLocaleString('de-DE');

/**
 * The sales lines the purchasing aid averages (EOS-62), opened from
 * "Absatz pro Tag" and from the warning about a distorting order.
 */
export function SalesHistoryDialog({ itemId, itemName, onClose }: SalesHistoryDialogProps) {
  const { data, isPending, isError } = usePreisToolSalesHistory(itemId, true);
  const total = data?.sales.reduce((sum, line) => sum + line.quantity, 0) ?? 0;

  return (
    <DsModal
      open
      onClose={onClose}
      size="large"
      title={data ? `Verkäufe der letzten ${data.periodDays} Tage` : 'Verkäufe'}
      description={`${itemId} · ${itemName}${data ? ` · ${pieces(total)} Stück in ${data.sales.length} Positionen` : ''}`}
      footer={<DsButton onClick={onClose}>Schließen</DsButton>}
    >
      {isPending ? (
        <div className="pt-fix-empty">Lade Verkäufe…</div>
      ) : isError || !data ? (
        <div className="pt-fix-empty">Fehler beim Laden der Verkäufe.</div>
      ) : data.sales.length === 0 ? (
        <div className="pt-fix-empty">Keine Verkäufe in den letzten {data.periodDays} Tagen.</div>
      ) : (
        <table className="pt-sales-table">
          <thead>
            <tr>
              <th>Datum</th>
              <th>Beleg-Nr.</th>
              <th>Kunde</th>
              <th className="num">Menge</th>
              <th className="num">Preis</th>
              <th className="num">Gesamtpreis</th>
            </tr>
          </thead>
          <tbody>
            {data.sales.map((line, i) => (
              <tr key={`${line.docNum}-${i}`}>
                <td className="mono">{fmtDate(line.docDate)}</td>
                <td className="mono">{line.docNum}</td>
                <td>{line.customerName}</td>
                <td className="num mono">{pieces(line.quantity)}</td>
                <td className="num mono">{fmtEUR(line.unitPrice)}</td>
                <td className="num mono">{fmtEUR(line.lineTotal)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </DsModal>
  );
}
